import { ApiError, apiFetch } from './client';
/**
 * Any of these statuses means "the endpoint isn't there" — at which point
 * we quietly drop to the localStorage mock so the rest of the UI can light
 * up. We deliberately DO NOT fall back on 401 / 403 / 500 — those are
 * real auth or server failures and the user should see them instead of a
 * silent green check.
 */
function isFlagEndpointUnavailable(e) {
    return e instanceof ApiError && (e.status === 404 || e.status === 405 || e.status === 501);
}
export async function getUserFeatureFlags() {
    // Force-mock escape hatch: set localStorage key `nl:mock:feature-flags` to
    // 'force' to bypass the real API entirely (useful when the API returns a
    // stale / partial success but we want to iterate on UI against mock data).
    let mock = null;
    try {
        mock = await import('./feature-flags-mock');
    }
    catch {
        // Mock file not present — real API is the only path.
    }
    if (mock?.isMockForced()) {
        return mock.getUserFeatureFlags();
    }
    try {
        return await apiFetch('/user/feature-flags');
    }
    catch (e) {
        // Auto-fallback only in development. In production a 404 here would
        // silently turn flags ON via the mock's defaults — masking a real
        // misconfiguration. The force-mock escape hatch above still works
        // for explicit local UI iteration.
        if (process.env.NODE_ENV === 'development' && mock && isFlagEndpointUnavailable(e)) {
            return mock.getUserFeatureFlags();
        }
        throw e;
    }
}
